import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
} from "@angular/core";
import { VAIconRegistryService, plus, close } from "@va/core-library/icons";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "app-edit-charts-ticker",
  templateUrl: "./edit-charts-ticker.component.html",
  styleUrls: ["./edit-charts-ticker.component.scss"],
})
export class EditChartsTickerComponent implements OnInit {
  @Input() addRowTableData: Array<any>;
  @Input() watchlists: Array<any>;
  @Input() recentlyVisitedCompanies: Array<any>;
  @Input() peerCompanies: Array<any>;
  @Input() mpt: number;
  @Input() maxHeight: string;
  @Input() type: string;
  @Input() max: number;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onTickerUpdate = new EventEmitter();
  @Output() onChangeTickers = new EventEmitter();
  @Output() mptUpdate = new EventEmitter();
  watchlisNameInput = "";
  selectedTickers: Array<any> = [];
  recentlyVisited: Array<any> = [];
  modalData: Array<any> = [];
  stdLineItems: Array<any> = [];
  legacyUrl = `${window.caUrl}/app`;
  visible: boolean;
  selectedMenuItem = "";
  lineItems: Array<any> = [];
  watchlistData: Array<any> = [];
  allItems: Array<any> = [];
  recentCompanies: Array<any> = [];
  isLoading = false;
  mptList = {
    1: "Industrial & commercial",
    2: "Banking & Financial Services",
    3: "Insurance",
  };
  constructor(
    private message: NzMessageService,
    private iconRegistryService: VAIconRegistryService,
  ) {
    this.iconRegistryService.registerIcons([plus, close]);
  }

  ngOnInit() {
    this.modalData = this.addRowTableData ? [...this.addRowTableData] : [];
    // this.watchlistData = JSON.parse(JSON.stringify(this.watchlists));
    // this.recentCompanies = JSON.parse(
    //   JSON.stringify(this.recentlyVisitedCompanies)
    // );
    let wData = [];
    for (let i = 0; i < this.watchlistData.length; i++) {
      // this.watchlists[i].company_info.map(el => {
      //   return {...el, isSelected: false};
      // })
      wData = this.watchlistData[i].company_info.map((el) => {
        const addedRowData = this.addRowTableData.find((obj) => {
          return obj.ticker === el.ticker;
        });
        if (addedRowData) {
          addedRowData.isSelected = true;
          const m = el.mpt;
          el = addedRowData;
          el["mpt"] = m;
        }
        // let obj = Object.assign({}, el);
        return el;
      });
      this.watchlistData[i].company_info = JSON.parse(JSON.stringify(wData));
    }
    this.selectedMenuItem =
      this.watchlistData.length && this.watchlistData[0].watchername;
    this.recentlyVisited =
      this.watchlistData.length && this.watchlistData[0].company_info;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.addRowTableData &&
      changes.addRowTableData.currentValue !==
        changes.addRowTableData.previousValue
    ) {
      this.modalData = this.addRowTableData ? [...this.addRowTableData] : [];
    }
    if (
      changes.watchlists &&
      changes.watchlists.currentValue !== changes.watchlists.previousValue
    ) {
      this.watchlistData = JSON.parse(JSON.stringify(this.watchlists));
    }
    if (
      changes.recentlyVisitedCompanies &&
      changes.recentlyVisitedCompanies.currentValue !==
        changes.recentlyVisitedCompanies.previousValue
    ) {
      this.recentCompanies = JSON.parse(
        JSON.stringify(this.recentlyVisitedCompanies),
      );
      const recentViewCompanies = this.recentlyVisitedCompanies.map((el) => {
        const company = {
          name: el.name,
          ticker: el.ticker,
          sli_comps_id: 0,
          mpt: el.mpt,
          isSelected: false,
        };
        return company;
      });
      const peerCompanies = this.peerCompanies.map((pc) => {
        const company = {
          name: pc.name,
          ticker: pc.ticker,
          sli_comps_id: 0,
          mpt: pc.mpt,
          isSelected: false,
        };
        return company;
      });
      if (this.type !== "create") {
        const recentViewCompany = {
          watchername: "Recently viewed (up to 30)",
          company_info: recentViewCompanies,
        };
        this.watchlistData.unshift(recentViewCompany);
        const peerData = {
          watchername: "Suggested Peers",
          company_info: peerCompanies,
        };
        if (peerCompanies.length) {
          this.watchlistData.unshift(peerData);
        } else {
          this.watchlistData.push(peerData);
        }
      }
    }
    let wData = [];
    for (let i = 0; i < this.watchlistData.length; i++) {
      // this.watchlists[i].company_info.map(el => {
      //   return {...el, isSelected: false};
      // })
      wData = this.watchlistData[i].company_info.map((el) => {
        const addedRowData = this.addRowTableData.find((obj) => {
          return obj.ticker === el.ticker;
        });
        if (addedRowData) {
          addedRowData.isSelected = true;
          const m = el.mpt;
          el = addedRowData;
          el["mpt"] = m;
        }
        // let obj = Object.assign({}, el);
        return el;
      });
      this.watchlistData[i].company_info = JSON.parse(JSON.stringify(wData));
    }
    this.selectedMenuItem =
      this.watchlistData.length && this.watchlistData[0].watchername;
    this.recentlyVisited =
      this.watchlistData.length > 0 ? this.watchlistData[0].company_info : [];
  }

  addTicker(params) {
    if (this.modalData.length === 0 && this.mpt === null) {
      this.mpt = params[0].mpt;
      this.mptUpdate.emit(this.mpt);
    }
    const tickerExist = this.modalData.filter((data) => {
      return data.ticker === params[0].ticker;
    });
    const mpt = params[0].mpt;
    if (mpt === this.mpt) {
      if (tickerExist.length === 0) {
        for (let i = 0; i < this.watchlistData.length; i++) {
          this.watchlistData[i].company_info.map((el) => {
            if (params[0].ticker === el.ticker) {
              el.isSelected = true;
            }
            return el;
          });
        }
        params[0].isSelected = true;
        this.modalData.push(params[0]);
        this.onChangeTickers.emit(this.modalData);
      }
    } else {
      this.message.create(
        "error",
        `Error: We currently cannot create a chart table with tickers from BOTH ${
          this.mptList[this.mpt]
        } and ${this.mptList[mpt]} sectors.`,
      );
    }
  }

  onWatchlistSelect(e, d) {
    this.selectedMenuItem = d.watchername;
    this.recentlyVisited = d.company_info;
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
  }

  addSearchedTicker(tickerInfo): void {
    if (this.modalData.length === 0 && this.mpt === null) {
      this.mpt = tickerInfo.mpt;
      this.mptUpdate.emit(this.mpt);
    }
    const company = {};
    company["name"] = tickerInfo.full_name;
    company["sli_comps_id"] = 0;
    company["ticker"] = tickerInfo.ticker;
    company["mpt"] = tickerInfo.mpt;
    company["isSelected"] = true;
    const mpt = tickerInfo.mpt;

    if (this.mpt === mpt) {
      const tickerExist = this.modalData.filter((data) => {
        return data.ticker === tickerInfo.ticker;
      });
      if (tickerExist.length === 0) {
        this.addTicker([company, false]);
      } else {
        this.message.create("info", "This ticker is already present.");
      }
    } else {
      this.message.create(
        "error",
        `Error: We currently cannot create a chart with tickers from BOTH ${
          this.mptList[this.mpt]
        } and ${this.mptList[mpt]} sectors.`,
      );
    }
  }

  removeTicker(company) {
    // if(company.sli_comps_id){
    for (let i = 0; i < this.watchlistData.length; i++) {
      this.watchlistData[i].company_info.map((el) => {
        if (company.ticker === el.ticker) {
          el.isSelected = false;
        }
        return el;
      });
    }
    //}
    // else{
    //   company.isSelected = false;
    // }
    //company.isSelected = false;

    const index = this.modalData.indexOf(company);
    this.modalData.splice(index, 1);
    if (this.modalData.length < 1) {
      this.mpt = null;
    }
    this.onChangeTickers.emit(this.modalData);
  }

  addAllTickers() {
    let err = false;
    const len = this.recentlyVisited.length;
    for (let i = 0; i < len; i++) {
      const company = this.recentlyVisited[i];
      if (company.mpt === this.mpt || this.mpt === null)
        this.addTicker([company, false]);
      else {
        err = true;
      }
    }
    if (err) {
      this.message.create(
        "error",
        `Error: We currently cannot create a chart with Tickers across Industrial & Commercial, Banking & Financial Services, and Insurance sectors.`,
      );
    }
  }

  removeAllTickers() {
    this.mpt = null;
    this.modalData = [];
    this.onChangeTickers.emit(this.modalData);
    for (let i = 0; i < this.watchlistData.length; i++) {
      this.watchlistData[i].company_info.map((el) => {
        // let obj = Object.assign({}, el);
        el.isSelected = false;
        return el;
      });
    }
  }

  updateTickers() {
    this.onTickerUpdate.emit(this.modalData);
  }

  changeTickers() {
    this.onChangeTickers.emit(this.modalData);
  }

  onCancelModal() {
    this.modalData = this.addRowTableData ? [...this.addRowTableData] : [];
    let wData = [];
    for (let i = 0; i < this.watchlistData.length; i++) {
      wData = this.watchlistData[i].company_info.map((el) => {
        el.isSelected = false;
        const addedRowData = this.addRowTableData.find((obj) => {
          return obj.ticker === el.ticker;
        });
        if (addedRowData) {
          addedRowData.isSelected = true;
          const m = el.mpt;
          el = addedRowData;
          el["mpt"] = m;
        }
        return el;
      });
      this.watchlistData[i].company_info = JSON.parse(JSON.stringify(wData));
    }
    this.selectedMenuItem =
      this.watchlistData.length && this.watchlistData[0].watchername;
    this.recentlyVisited =
      this.watchlistData.length && this.watchlistData[0].company_info;
  }
}
